module.exports = __webpack_public_path__ + "logo.6ad47802.png";